<template lang="pug">
  .address-layout
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    v-container(v-else style="max-width:600px")
      div.text-center
        div.caption Total Amount
        div.display-1.font-weight-bold {{ bill.total_amount | displayPrice($currency) }}

      v-card.mt-2(outlined)
        v-simple-table.mb-2
          thead
            tr
              th.text-center.basic400(style="width: 10%") No
              th.basic400 Item
              th.basic400.text-right Total price

          tbody(v-if="bill")
            tr(v-for="(item, index) in bill.items" :key="item.description")
              td.text-center
                div {{ index + 1 }}
              td
                div {{ item.description }}
              td.text-right
                div {{ item.subtotal_amount | displayPrice($currency) }}

      v-form.mt-4(ref="form")
        .payment-method
          div.title.text-center.font-weight-bold.mb-3 Payment Method
          v-select.mt-2(v-model="form.paymentMethod" placeholder="Select payment method" :items="paymentMethods" item-text="name" item-value="id" background-color="basic200" height="40" outlined dense append-icon="mdi-chevron-down" :rules="rules.is_selected")
            template(v-slot:item="{ item }")
              v-list-item-content
                v-list-item-title {{ item.name }}

          v-card.pa-4.mt-2(v-if="form.paymentMethod" flat outlined style="border:1px solid var(--v-basic300);")
            card-list.mt-4(v-if="form.paymentMethod === 'card'" @change="form.card = $event.id")
            .online-payment.mt-4(v-else-if="form.paymentMethod === 'fpx' && company.currency.currency_code === 'MYR'")
              div.subtitle.mb-3 Choose bank for payment
              v-card.mb-12
                FPXPicker(v-model="form.fpxBankCode")

      v-footer(fixed app inset)
        v-container.px-0(style="max-width:580px")
          v-btn.mr-2(block v-if="form.paymentMethod == 'card'" color='info500' depressed @click="proceedToPay" :disabled="!form.card" :loading="isProcessing")
            .button-AA-medium.basic100--text {{ $t('proceed_to_pay') }}
          v-btn.mr-2(block v-else-if="form.paymentMethod == 'fpx'" color='info500' depressed @click="proceedToPay" :disabled="company.currency.currency_code === 'MYR' && !form.fpxBankCode" :loading="isProcessing")
            .button-AA-medium.basic100--text {{ $t('proceed_to_pay') }}
          v-btn.mr-2(block v-else color='info500' depressed @click="proceedToPay")
            .button-AA-medium.basic100--text {{ $t('proceed_to_pay') }}

    .modals
      y-dialog(v-model='isProcessing' persistent width='300')
        v-card(color='primary' dark)
          v-card-text.pt-3
            | Processing payment...
            v-progress-linear.mb-0.mt-4(indeterminate='', color='white')
            div.mt-4.font-weight-bold Please do not refresh or navigate away from this screen

</template>

<script>
import { mapActions } from 'vuex'
import HeadBar from '@/components/forms/HeadBar.vue'
import CardList from '@/components/billing/CardList.vue'
import FPXPicker from '@/components/FPXPicker.vue'

export default {
  name: 'PayBill',
  components: { HeadBar, CardList, FPXPicker },
  props: ['company', 'id'],
  data: () => ({
    isFetching: true,
    bill: null,
    form: {
      paymentMethod: 'fpx',
      card: null,
      fpxBankCode: null
    },
    paymentMethods: [
      { name: 'Credit or debit card', id: 'card'},
      { name: 'Online banking', id: 'fpx'}
    ],
    isProcessing: false,
    rules: {
      is_selected: [(v) => v !== null || 'This field is required'],
    },
  }),
  mounted () {
    this.fetchBill()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchBill() {
      this.isFetching = true
      let url = `/subscription/bills/${this.id}`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.bill = response.data
      }).catch(() => {})
    },
    proceedToPay () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isProcessing = true
      const data = {}
      if (this.form.paymentMethod === 'card') {
        data.card = this.form.card
        this.subscribeByCard(this.id, data)
      } else if (this.form.paymentMethod === 'fpx') {
        if (this.company.currency.currency_code === 'IDR') {
          data.method = 'xendit'
        } else {
          data.method = 'laravel'
        }
        data.bank_code = this.form.fpxBankCode
        this.subscribeByFpx(this.id, data)
      }
    },
    subscribeByCard (bill, data) {
      this.$axios.post(`/subscription/bills/${bill}/charge_card/`, data)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.payment_successful')])
          setTimeout(() => {
            location.href = '/admin/billing/clinic-bills/'
          }, 1000)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_subscribe_card')])
          this.isProcessing = false
        })
    },
    subscribeByFpx (bill, data) {
      this.$axios.post(`/subscription/bills/${bill}/request_manual_payment/`, data)
        .then(resp => {
          const data = resp.data
          setTimeout(() => {
            location.href = data.bill_url
          }, 1000)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_subscribe_method')])
          this.isProcessing = false
        })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "proceed_to_pay": "Proceed To Pay"
  },

   "id": {
    "proceed_to_pay": "Teruskan ke pembayaran"
  }
}
</i18n>
